export default __webpack_public_path__ + "static/media/maheep.b11af563.png";